"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A897))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRDownload = createSVGIcon(
  <path
    d="M21.25 14.25v7H2.75v-7M12 2.75v14.875m-6.5-6.71 6.5 6.71 6.5-6.71"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRDownload",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "BCVNEI",
      defaultMessage: "Download",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
